<template>
  <f7-page name="Question" class="question-page dark-page">
    <f7-navbar title="Question" back-link="Back"></f7-navbar>


      <div class="question-name">
        <h3>{{ event.title }}</h3>
        <p>
          <i class="az-icon-calendar-date-schedule"></i>
          {{ event.title }}
        </p>
      </div>

      <!-- Question Content-->
      <div class="question-box" v-if="quiz.questions">
        <div class="question-content" v-for="(question, index) in quiz.questions" :key="question.id" v-show="index == currentQuestion">
          <h3 class="question-content-title">{{ question.question }}</h3>
          <div class="radio-container">
            <ul>
            <li v-for="ans in question.answers" :key="ans.id" @click.prevent="setAnswer(question.id, ans.id)">
              <input type="radio" :id="ans.id" :value="ans.id" name="selector">
              <label :for="ans.id" :class="{'checked': selectedAns == ans.id }">{{ ans.answer }}</label>
              <div :class="{'check': true, 'checked': selectedAns == ans.id }"><div class="inside"></div></div>
            </li>
          </ul>
          </div>
        </div>
        <div class="question-button">
          <a href="#" class="button button-fill" @click="nextOrSubmit">{{ currentQuestion == (quiz.questions.length -1) ? 'Submit' : 'Next' }}</a>
        </div>
      </div>
  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      event: {},
      quiz: {},
      currentQuestion: 0,
      userAnswers: [],
      selectedAns: 0
    }
  },
  methods: {
    nextOrSubmit: function() {
      if( this.currentQuestion == this.quiz.questions.length -1) {
        // submit
        this.$f7.preloader.show()
        this.$http.post( this.$root.apiBaseURL + 'save-quiz-answers', {'answers': this.userAnswers} )
          .then( (res) => {
            this.$f7.dialog.alert( res.data.message , 'Success')
            this.$f7.view.current.router.navigate('/')
            this.$f7.preloader.hide()
          })
          .catch( (error) => {
            console.log(error)
            this.$f7.preloader.hide()
          })
      } else {
        var current = this.currentQuestion + 1
        console.log(current)
        if(current > this.userAnswers.length) {
          this.$f7.dialog.alert('You must select an answer')
          return false
        }

        this.currentQuestion++
      }
    },
    setAnswer: function(qid, aid) {
      this.selectedAns = aid
      this.userAnswers = this.userAnswers.filter( (item) => {
        return item.question_id != qid
      })

      this.userAnswers.push({
        question_id: qid,
        answer_id: aid,
        user_id: this.$root.user.id
      })
    }
  },
  mounted: function() {
    this.event = JSON.parse(sessionStorage.getItem('currentEvent'))
    this.quiz = JSON.parse(sessionStorage.getItem('currentQuiz'))
  }
}
</script>